import ListSection from "./List";
import LoadingSection from "./Loading";
import ResultSection from "./Result";

export const SECTIONS = [ListSection, LoadingSection, ResultSection];
